import { Store } from 'src/store';

const getAppSessionId = (store: Store) => store.app.appSessionId;

export default getAppSessionId;
